import React, { useState, useRef } from 'react'
import { ReactComponent as LanguageIcon } from 'assets/svg/settings/language.svg'
import { ReactComponent as ArrowDownIcon } from 'assets/svg/shared/arrow_down.svg'
import { ReactComponent as TickIcon } from 'assets/svg/settings/tick_blue.svg'
import { ModalAsDropdown } from 'components/shared'
import { ModalStyles } from 'components/pages/settings/sound-and-devices/config/ModalStyles'
import { Languages, setKavkomLanguageCookie } from 'lang/i18n'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'

const defaultDropdownImgClassName = 'sound-and-devices__item-btn__img'
const activeClassName = `${defaultDropdownImgClassName}--active`

export const Language = () => {
    const selectedLanguage = Languages.find((item) => item.id === i18n.language)
    const { t } = useTranslation()

    // State
    const [modalStyles, setModalStyles] = useState(ModalStyles)
    const [isModalVisible, setModalVisible] = useState(false)
    const [modalContent, setModalContent] = useState([])
    const selectRef = useRef(null)

    // Actions
    const toggleModal = (event, ref, config) => {
        if (event) {
            const viewPortWidth = window.innerWidth
            const { y } = event.target.getBoundingClientRect()

            setModalStyles({
                ...modalStyles,
                content: {
                    ...modalStyles.content,
                    top: `${y + 25}px`,
                    left: `${viewPortWidth / 2}px`
                }
            })
        }
        if (ref) {
            classListActionProvider(ref, 'add')
        } else {
            ;[selectRef].forEach(
                (ref) => classListActionProvider(ref, 'contains') && classListActionProvider(ref, 'remove')
            )
        }

        setModalContent(renderModalContent(config))
        setModalVisible(!isModalVisible)
    }

    const classListActionProvider = (ref, action) => ref.current.children[0].classList[action](activeClassName)

    const renderModalContent = (modalConfig) => {
        return modalConfig
            ? modalConfig.map(({ id, name, disabled = false }) => (
                !disabled && <div
                      key={id}
                      className="sound-and-devices__dropdown-item d-flex justify-content-between align-items-center"
                      onClick={() => onDropdownSelect(id)}
                  >
                      <span className="sound-and-devices__dropdown-item__text">{t(name)}</span>
                      {selectedLanguage.id === id && <TickIcon />}
                  </div>
              ))
            : []
    }

    const onDropdownSelect = (lang) => {
        toggleModal()
        setModalVisible(false)
        i18n.changeLanguage(lang)
        setKavkomLanguageCookie(lang)
    }

    return (
        <>
            <div className="account__language mb-4">
                <span className="account__title">{t('language')}</span>
                <div className="account__language__item account__white-box d-flex justify-content-between align-items-center">
                    <div className="account__language__item-label d-flex align-items-center">
                        <LanguageIcon />
                        <span>{selectedLanguage.name}</span>
                    </div>
                    <button
                        type="button"
                        ref={selectRef}
                        className="sound-and-devices__item-btn d-flex align-items-center"
                        onClick={(e) => toggleModal(e, selectRef, Languages)}
                    >
                        {t('select')} <ArrowDownIcon />
                    </button>
                </div>
            </div>
            <ModalAsDropdown
                isModalVisible={isModalVisible}
                toggleModal={toggleModal}
                modalContent={() => modalContent}
                customModalStyles={modalStyles}
            />
        </>
    )
}
